module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "books"
    }
  }, [_c('Vswipe'), _vm._v(" "), _c('types', {
    attrs: {
      "title": _vm.title,
      "msg": _vm.msg
    }
  }), _vm._v(" "), _c('Vbottom')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-37b614ae!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/book/book.vue
// module id = 57
// module chunks = 1